import { BASVURU_MUELLIF_GUNCELLE } from "../constants/requestUrls";

import { postRequest } from "../request";

const BasvuruMuellifGuncelle = (props) => {
  let data = {};
  if (props !== undefined)
    data = JSON.stringify(props);
  
  return postRequest({ url: BASVURU_MUELLIF_GUNCELLE, data });
}

export default BasvuruMuellifGuncelle;